var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75097 16.583C6.3763 16.583 6.0603 16.4547 5.80297 16.198C5.5463 15.9407 5.41797 15.6247 5.41797 15.25V5.5H4.41797V4.417H8.00097V3.521H12.001V4.417H15.584V5.5H14.584V15.229C14.584 15.6177 14.4556 15.9407 14.199 16.198C13.9416 16.4547 13.6256 16.583 13.251 16.583H6.75097ZM13.501 5.5H6.50097V15.25C6.50097 15.3053 6.52864 15.361 6.58397 15.417C6.63997 15.4723 6.69564 15.5 6.75097 15.5H13.251C13.3063 15.5 13.362 15.4723 13.418 15.417C13.4733 15.361 13.501 15.3053 13.501 15.25V5.5ZM8.33397 14H9.41797V7H8.33397V14ZM10.584 14H11.668V7H10.584V14ZM6.50097 5.5V15.5V15.25V5.5Z",
    fill: "#FF4343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash2);
export default __webpack_public_path__ + "static/media/trash_2.7b50e0e9d4b817db1e845a689a8787a3.svg";
export { ForwardRef as ReactComponent };